import { render } from "./goldFishResult.vue?vue&type=template&id=0c8a483c"
import script from "./goldFishResult.vue?vue&type=script&lang=js"
export * from "./goldFishResult.vue?vue&type=script&lang=js"

import "./goldFishResult.vue?vue&type=style&index=0&id=0c8a483c&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__